module.exports = __webpack_public_path__ + "img/windSuction--isntSpanBySpan.4759ad1f.png";